import { ExplanationModel } from "../models/ExplanationModel";
import { Example } from "../models/ExampleModel";
import { VerbConjugation } from "../models/VerbConjugationModel";

// Explanation Data
export const preteritoPluscuamperfectoExplanation: ExplanationModel = {
    title: "📖 What is Pretérito Pluscuamperfecto?",
    description: `The Past Perfect is used to describe actions that occurred before another past event.`,
    bulletPoints: [
        "Expresses an action completed before another past event. ➝ 'Cuando llegué a casa, ya habían cenado.' (When I got home, they had already had dinner.)",
        "Describes past experiences that happened before a certain moment. ➝ 'Nunca había visto algo así antes.' (I had never seen anything like this before.)",
        "Helps structure chronological storytelling by narrating past events. ➝ 'Cuando entré, el espectáculo ya había empezado.' (When I entered, the show had already started.)",
    ],
    examples: [
        "📌 Formation: Imperfect form of 'haber' + past participle",
    ]
};

// Example Sentences Data
export const preteritoPluscuamperfectoExamples: Example[] = [
    {
        sentence: "Cuando llegué a casa, ya habían cenado.",
        explanation:
            "🍽️ Completed Action – 'When I arrived home, they had already had dinner.' This sentence shows an action that happened before another past event.",
    },
    {
        sentence: "Antes del examen, ya había estudiado muchísimo.",
        explanation:
            "📖 Preparation – 'Before the exam, I had already studied a lot.' The past perfect highlights that studying was completed before the exam.",
    },
    {
        sentence: "Nunca había visto algo tan impresionante hasta ese día.",
        explanation:
            "🌟 First Experience – 'I had never seen anything so impressive until that day.' The use of past perfect emphasizes a past event before a reference point.",
    },
    {
        sentence: "Habíamos terminado el proyecto mucho antes de la fecha límite.",
        explanation:
            "✅ Early Completion – 'We had finished the project long before the deadline.' The past perfect indicates completion before a specific past moment.",
    },
    {
        sentence: "Él ya había salido cuando llamaste.",
        explanation:
            "📞 Sequence of Actions – 'He had already left when you called.' The past perfect is used to express that leaving happened before the call.",
    },
];

// Regular Conjugation Table
export const preteritoPluscuamperfectoRegular: VerbConjugation[] = [

    {
        verb: "Hablar",
        conjugations: ["había hablado", "habías hablado", "había hablado", "habíamos hablado", "habíais hablado", "habían hablado"],
    },
    {
        verb: "Comer",
        conjugations: ["había comido", "habías comido", "había comido", "habíamos comido", "habíais comido", "habían comido"],
    },
    {
        verb: "Vivir",
        conjugations: ["había vivido", "habías vivido", "había vivido", "habíamos vivido", "habíais vivido", "habían vivido"],
    },
]

// Irregular Conjugation Table
export const preteritoPluscuamperfectoIrregular: VerbConjugation[] = [
    {
        verb: "Ver",
        conjugations: ["había visto", "habías visto", "había visto", "habíamos visto", "habíais visto", "habían visto"],
    },
    {
        verb: "Escribir",
        conjugations: ["había escrito", "habías escrito", "había escrito", "habíamos escrito", "habíais escrito", "habían escrito"],
    },
    {
        verb: "Decir",
        conjugations: ["había dicho", "habías dicho", "había dicho", "habíamos dicho", "habíais dicho", "habían dicho"],
    },
]
